import { Link } from 'react-router';
import { Button } from '@/components/ui/button';
import { GetStartedLink } from '@/constants/navigation';
import { ProjectPrompt } from '@/pages/Contact/data';

export function ProjectPromptCard() {
  return (
    <div className="pad-grid rounded-xl border border-grid p-6 sm:p-8">
      <h2 className="text-xl font-bold text-graphite">{ProjectPrompt.title}</h2>
      <p className="mt-2 leading-relaxed text-steel">{ProjectPrompt.description}</p>
      <Button asChild className="mt-6">
        <Link to={GetStartedLink.to}>{GetStartedLink.label}</Link>
      </Button>
    </div>
  );
}